import { StoreType } from "@omni/types/api/store/cloud/shared/enums/storeType.enum";
import { CloudStore } from "@omni/types/api/store/cloud/store.model";
import { entries } from "@omni/utils/object.utils";
import { useEffect, useMemo } from "react";

import { useStoreServiceApi } from "@/api/hooks/storeService.hook";
import { GetStoreStrategy } from "@/services/store.service";

import { useStore } from "./useStore.hook";

type useAssociatedStoreProps = {
    strategy: GetStoreStrategy;
    sku?: string;
    type: StoreType;
};

const useAssociatedStore = ({
    strategy,
    sku,
    type
}: useAssociatedStoreProps) => {
    const { store } = useStore({ strategy, sku });

    const [{ data, loading }, loadStore] = useStoreServiceApi<
        any,
        any,
        CloudStore
    >(
        {
            url: "/stores/"
        },
        { manual: true }
    );

    const requestConfig = useMemo(() => {
        if (!store) return;

        const associatedStore = entries(store.associatedStores)
            .find(([t]) => t === type)
            ?.at(1)
            ?.at(0);

        return {
            url: `/localized/stores/${associatedStore}`,
            params: {
                includeProductAvailability: !!sku,
                sku: sku
            }
        };
    }, [sku, store, type]);

    useEffect(() => {
        if (!requestConfig) return;
        if (data) return;
        if (loading) return;

        loadStore(requestConfig);
    }, [loading, data, requestConfig, loadStore]);

    return { associatedStore: data };
};

export { useAssociatedStore };
